import { createContext, useContext } from 'react';

import { type PieDonutConfig } from '../types/pie-chart.config.js';

export const PieChartConfigContext = createContext<PieDonutConfig>(
  {} as PieDonutConfig,
);

export const usePieChartConfig = () => useContext(PieChartConfigContext);
